import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";

import styles from "./before-footer-text.module.scss";

function BeforeFooterText({content}) {
  function createMarkup(html) {
    return {__html: html};
  }
  return (
    <Grid container>
      <Grid item md={7} xs={12}>
        <div
          className={styles.root}
          dangerouslySetInnerHTML={createMarkup(content)}
        />
      </Grid>
    </Grid>
  );
}

BeforeFooterText.propTypes = {
  content: PropTypes.string
};

export default BeforeFooterText;
